import { render, staticRenderFns } from "./AddIncomeTaxSlabComponent.vue?vue&type=template&id=e825c246&"
import script from "./AddIncomeTaxSlabComponent.vue?vue&type=script&lang=js&"
export * from "./AddIncomeTaxSlabComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports